export default __webpack_public_path__ + "static/arrow_03_white-846eb126e968d57afb55f30b8e9a02e7.png";